import { render } from "./Xtgg.vue?vue&type=template&id=32549002"
import script from "./Xtgg.vue?vue&type=script&lang=js"
export * from "./Xtgg.vue?vue&type=script&lang=js"

import "./Xtgg.vue?vue&type=style&index=0&id=32549002&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__